import { publicEnv } from "@/config/env";
import CoursesList from "@/features/courses/components/courses-list";
import { HeroMarkdownSection } from "@/features/shared/components/hero-markdown-section-client";
import { HeroMarkdownSkeleton } from "@/features/shared/components/hero-markdown-skeleton";
import { NotFoundPage } from "@/features/shared/components/not-found-page";
import { useLng } from "@/hooks/use-lng";
import { appTitleHead } from "@/lib/app-document-title";
import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";

export const Route = createFileRoute("/_app/courses/")({
  head: () => appTitleHead("courses"),
  component: CoursesPage
});

function CoursesPage() {
  const lng = useLng();

  if (publicEnv.USE_BOOKING === "false" || publicEnv.USE_COURSE === "false") {
    return <NotFoundPage />;
  }

  return (
    <div className="w-full">
      <Suspense fallback={<HeroMarkdownSkeleton />}>
        <HeroMarkdownSection lng={lng} section="courses" />
      </Suspense>
      <CoursesList />
    </div>
  );
}
